<template>
  <div class="container gg54">
    <span>
      <slot></slot>
      <el-cascader
        :style="cssVars"
        class="aaa"
        :class="{ last: isLast }"
        v-model="value"
        :popper-class="takeOut || 'takeOut2 dsg65sdgb'"
        :options="options"
        ref="cascaderCase"
        :show-all-levels="false"
        :placeholder="placeholder"
        :collapse-tags="collapsetags"
        :props="{
          expandTrigger: 'hover',
          checkStrictly: checkStrictly,
          multiple: multiple,
        }"
        @change="handleChange"></el-cascader>
    </span>
  </div>
</template>

<script>
export default {
  // 从父组件传值的
  props: {
    options: {
      type: Array,
      default: '',
    },
    wide: {
      type: Boolean,
      default: false,
    },

    default: {
      type: [String, Array],
      default: '',
    },
    isDelete: {
      type: Boolean,
      default: false,
    },
    checkStrictly: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    collapsetags: {
      type: Boolean,
      default: false,
    },
    needarr: {
      type: Boolean,
      default: false,
    },
    takeOut: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
  },
  methods: {
    handleChange(val) {
      console.log(val, '爱你一一万年');
      let nodes = this.$refs.cascaderCase.getCheckedNodes();
      let nodesARR = nodes.map((node) => {
        return node.value;
      });

      // -------------------为node 部分---------------------------------
      let value = null;
      // ---------------------------------------------
      if (this.isDelete && val.length == 1) {
        this.isLast = true;
      } else {
        this.isLast = false;
      }
      // ---------------------------------------------

      if (this.multiple) {
        if (Array.isArray(val[0])) {
          value = [];
          val.forEach((node) => {
            node.forEach((e) => {
              value.push(e);
            });
          });

          value = [...new Set(value)];
        } else {
          value = val;
        }
      } else {
        value = this.needarr ? val : val[val.length - 1];
      }

      this.$emit('CCascader_select_val', value);

      // let index = null
      // nodesARR.forEach((node,idx)=>{
      //   let flag =  value.includes(node)
      //   if(flag == -1){
      //           console.log(node);
      //     index = idx
      //   }
      // })

      // nodesARR.splice(index,1)

      this.$emit('CCascader_select_node', nodesARR);
    },
  },
  components: {},
  computed: {
    cssVars() {
      return {
        '--val3': this.val3,
      };
    },
  },
  watch: {},

  created() {
    if (this.isDelete && this.value.length == 1) {
      this.isLast = true;
    } else {
      this.isLast = false;
    }

    // this.handleChange(this.value)
  },
  data() {
    return {
      value: this.default,
      isLast: false,
      val3: this.wide ? '300px' : 'auto',

      //  dButtons1:['概览','市值相关','流动性相关'],
      //  dButtons1_current:'概览',
    };
  },
};
</script>

<style lang="less" scoped>
.gg54 {
  /deep/.el-tag {
    font-size: calc(var(--ROOTFONTFIZE) * (12 / 144));
    height: calc(var(--ROOTFONTFIZE) * (24 / 144));
    padding: 0 calc(var(--ROOTFONTFIZE) * (8 / 144));
    line-height: calc(var(--ROOTFONTFIZE) * (22 / 144));
  }
}
.container {
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  font-weight: 400;
  letter-spacing: 0.25px;
  line-height: calc(var(--ROOTFONTFIZE) * (28 / 144));
  display: flex;
  align-items: center;
}

span {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  color: var(--chart_title);
}

// 切换按钮  start --------------------------------------------
::v-deep .el-cascader {
  background-color: var(--cascader-bgc) !important;
  padding: 0 !important;
  height: calc(var(--ROOTFONTFIZE) * (35 / 144)) !important;
  line-height: calc(var(--ROOTFONTFIZE) * (35 / 144)) !important;
  border: none;
  margin-left: calc(var(--ROOTFONTFIZE) * (20 / 144));
  display: flex !important;
  align-items: center !important;
  width: var(--val3) !important;
  border-radius: 3px !important;
}

::v-deep .el-input__inner {
  background-color: rgba(0, 0, 255, 0) !important;
  border: none;
  padding: 0 !important;
  margin: 0 !important;
  padding-left: calc(var(--ROOTFONTFIZE) * (5 / 144)) !important;
  padding: calc(var(--ROOTFONTFIZE) * (5 / 144)) calc(var(--ROOTFONTFIZE) * (10 / 144));
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  font-weight: 400;
  letter-spacing: 0px;
  color: var(--autocomplete_suggestion__list_color);
  display: flex !important;
  align-items: center !important;
  // width: 100% !important;
  width: var(--val3) !important;
}

::v-deep .el-input__suffix {
  height: 100%;
  padding-right: calc(var(--ROOTFONTFIZE) * (10 / 144));
}

::v-deep .el-input__suffix-inner {
}

::v-deep .el-tag.el-tag--info {
  background-color: var(--cascader-bgc2) !important;
  color: var(--cascader-color) !important;
  border: none !important;
  font-weight: normal !important;
  display: flex;
  align-items: center;
}

::v-deep .el-tag .el-icon-close {
  background-color: #232324 !important;
  color: #fff !important;
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144)) !important;
}

::v-deep .el-cascader-menu__list {
  // background-color: #fff !important;
}

::v-deep .el-select-dropdown {
  background-color: var(--Select-bgc2) !important;
  border: none !important;
}
::v-deep .last .el-tag .el-icon-close {
  display: none;
}

::v-deep .el-checkbox__inner.is-indeterminate .el-checkbox__inner {
}

::v-deep .el-cascader-menu__list.el-cascader-node.el-checkbox {
  display: none;
}

::v-deep .el-icon-arrow-right .el-cascader-node__postfix {
  color: red !important;
}

// ::v-deep .el-checkbox.is-disabled{
//     display: none !important;
// }
</style>
